import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  ProgressGauge,
  ProgressGaugeCollapsed,
} from '@saucelabs/sl-component-gauges';
import {
  MobileIcon, DesktopIcon,
} from '@saucelabs/sl-component-icons';

const SessionChart = ({
  collapsed,
  collapsedLabel,
  current,
  label,
  limit,
  onClick,
}) => {
  const fillPercentage = Math.abs(limit) < Number.MIN_VALUE ?
    100 :
    Math.round(((current > 0 ? current : 0) / limit) * 100);
  const exceeded = fillPercentage >= 100;
  const almostExceeded = !exceeded && fillPercentage >= 90;

  const currentLabelClass = classNames('transition-all duration-1000', {
    'text-blue-400': !almostExceeded && !exceeded,
    'text-orange-600': almostExceeded,
    'text-red-900': exceeded,
  });

  const limitLabelClass = classNames('transition-all duration-1000', {
    'text-red-900': Number(limit) === 0,
  });

  if (collapsed) {
    return (
      <ProgressGaugeCollapsed
        almostExceeded={almostExceeded}
        current={current}
        exceeded={exceeded}
        Icon={label === 'Real' ? MobileIcon : DesktopIcon}
        label={collapsedLabel}
        limit={limit}
        onClick={onClick}
      >
        <div className="text-center flex justify-center align-baseline whitespace-pre">
          <span className={currentLabelClass}>{current}</span>
          <span className={limitLabelClass}>{` / ${limit}`}</span>
        </div>
      </ProgressGaugeCollapsed>
    );
  }

  // !collapsed
  return (
    <ProgressGauge
      almostExceeded={almostExceeded}
      current={current}
      exceeded={exceeded}
      label={label}
      limit={limit}
      onClick={onClick}
    >
      <div className="text-center flex justify-center align-baseline whitespace-pre">
        <span className={currentLabelClass}>{current}</span>
        <span className={limitLabelClass}>{` / ${limit}`}</span>
      </div>
    </ProgressGauge>
  );
};

SessionChart.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  collapsedLabel: PropTypes.string.isRequired,
  current: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  label: PropTypes.string.isRequired,
  limit: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  onClick: PropTypes.func,
};

SessionChart.defaultProps = {
  onClick: undefined,
};

export default SessionChart;
